/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Impero API
 * Legacy Impero .NET API (served under /v1).
 */
import { useMutation, useQuery, useSuspenseQuery } from "@tanstack/react-query";
import type {
    DataTag,
    DefinedInitialDataOptions,
    DefinedUseQueryResult,
    MutationFunction,
    QueryClient,
    QueryFunction,
    QueryKey,
    UndefinedInitialDataOptions,
    UseMutationOptions,
    UseMutationResult,
    UseQueryOptions,
    UseQueryResult,
    UseSuspenseQueryOptions,
    UseSuspenseQueryResult,
} from "@tanstack/react-query";

import axios from "axios";
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";

import type {
    LegacyClassificationUsers,
    LegacyClassificationsForUser,
    LegacyUpdateClassificationAccessRightsViewModel,
} from "../model";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

const withQueryKey = <T extends object, K>(
    query: T,
    queryKey: K
): T & { queryKey: K } => {
    const result = { queryKey } as T & { queryKey: K };
    for (const key of Object.keys(query)) {
        // The explicit queryKey always wins, matching the previous
        // `{ ...query, queryKey }` spread where it was set last.
        if (key === "queryKey") continue;
        Object.defineProperty(result, key, {
            enumerable: true,
            configurable: true,
            get: () => (query as Record<string, unknown>)[key],
        });
    }
    return result;
};

export const legacyClassificationClassifications = (
    options?: AxiosRequestConfig
): Promise<AxiosResponse<LegacyClassificationsForUser>> => {
    return axios.get(`/v1/Classification/Classifications`, options);
};

export const getLegacyClassificationClassificationsQueryKey = () => {
    return [`/v1/Classification/Classifications`] as const;
};

export const getLegacyClassificationClassificationsQueryOptions = <
    TData = Awaited<ReturnType<typeof legacyClassificationClassifications>>,
    TError = AxiosError<unknown>,
>(options?: {
    query?: Partial<
        UseQueryOptions<
            Awaited<ReturnType<typeof legacyClassificationClassifications>>,
            TError,
            TData
        >
    >;
    axios?: AxiosRequestConfig;
}) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getLegacyClassificationClassificationsQueryKey();

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof legacyClassificationClassifications>>
    > = ({ signal }) =>
        legacyClassificationClassifications({ signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof legacyClassificationClassifications>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type LegacyClassificationClassificationsQueryResult = NonNullable<
    Awaited<ReturnType<typeof legacyClassificationClassifications>>
>;
export type LegacyClassificationClassificationsQueryError = AxiosError<unknown>;

export function useLegacyClassificationClassifications<
    TData = Awaited<ReturnType<typeof legacyClassificationClassifications>>,
    TError = AxiosError<unknown>,
>(
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof legacyClassificationClassifications>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<
                        ReturnType<typeof legacyClassificationClassifications>
                    >,
                    TError,
                    Awaited<
                        ReturnType<typeof legacyClassificationClassifications>
                    >
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useLegacyClassificationClassifications<
    TData = Awaited<ReturnType<typeof legacyClassificationClassifications>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof legacyClassificationClassifications>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<
                        ReturnType<typeof legacyClassificationClassifications>
                    >,
                    TError,
                    Awaited<
                        ReturnType<typeof legacyClassificationClassifications>
                    >
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useLegacyClassificationClassifications<
    TData = Awaited<ReturnType<typeof legacyClassificationClassifications>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof legacyClassificationClassifications>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useLegacyClassificationClassifications<
    TData = Awaited<ReturnType<typeof legacyClassificationClassifications>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof legacyClassificationClassifications>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions =
        getLegacyClassificationClassificationsQueryOptions(options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getLegacyClassificationClassificationsSuspenseQueryOptions = <
    TData = Awaited<ReturnType<typeof legacyClassificationClassifications>>,
    TError = AxiosError<unknown>,
>(options?: {
    query?: Partial<
        UseSuspenseQueryOptions<
            Awaited<ReturnType<typeof legacyClassificationClassifications>>,
            TError,
            TData
        >
    >;
    axios?: AxiosRequestConfig;
}) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getLegacyClassificationClassificationsQueryKey();

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof legacyClassificationClassifications>>
    > = ({ signal }) =>
        legacyClassificationClassifications({ signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof legacyClassificationClassifications>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type LegacyClassificationClassificationsSuspenseQueryResult =
    NonNullable<
        Awaited<ReturnType<typeof legacyClassificationClassifications>>
    >;
export type LegacyClassificationClassificationsSuspenseQueryError =
    AxiosError<unknown>;

export function useLegacyClassificationClassificationsSuspense<
    TData = Awaited<ReturnType<typeof legacyClassificationClassifications>>,
    TError = AxiosError<unknown>,
>(
    options: {
        query: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof legacyClassificationClassifications>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useLegacyClassificationClassificationsSuspense<
    TData = Awaited<ReturnType<typeof legacyClassificationClassifications>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof legacyClassificationClassifications>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useLegacyClassificationClassificationsSuspense<
    TData = Awaited<ReturnType<typeof legacyClassificationClassifications>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof legacyClassificationClassifications>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useLegacyClassificationClassificationsSuspense<
    TData = Awaited<ReturnType<typeof legacyClassificationClassifications>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof legacyClassificationClassifications>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions =
        getLegacyClassificationClassificationsSuspenseQueryOptions(options);

    const query = useSuspenseQuery(
        queryOptions,
        queryClient
    ) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const legacyClassificationEditAccessRights = (
    classificationId: string,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<LegacyClassificationUsers>> => {
    return axios.get(
        `/v1/Classification/EditAccessRights/${classificationId}`,
        options
    );
};

export const getLegacyClassificationEditAccessRightsQueryKey = (
    classificationId: string
) => {
    return [`/v1/Classification/EditAccessRights/${classificationId}`] as const;
};

export const getLegacyClassificationEditAccessRightsQueryOptions = <
    TData = Awaited<ReturnType<typeof legacyClassificationEditAccessRights>>,
    TError = AxiosError<unknown>,
>(
    classificationId: string,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<typeof legacyClassificationEditAccessRights>
                >,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getLegacyClassificationEditAccessRightsQueryKey(classificationId);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof legacyClassificationEditAccessRights>>
    > = ({ signal }) =>
        legacyClassificationEditAccessRights(classificationId, {
            signal,
            ...axiosOptions,
        });

    return {
        queryKey,
        queryFn,
        enabled: classificationId !== null && classificationId !== undefined,
        ...queryOptions,
    } as UseQueryOptions<
        Awaited<ReturnType<typeof legacyClassificationEditAccessRights>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type LegacyClassificationEditAccessRightsQueryResult = NonNullable<
    Awaited<ReturnType<typeof legacyClassificationEditAccessRights>>
>;
export type LegacyClassificationEditAccessRightsQueryError =
    AxiosError<unknown>;

export function useLegacyClassificationEditAccessRights<
    TData = Awaited<ReturnType<typeof legacyClassificationEditAccessRights>>,
    TError = AxiosError<unknown>,
>(
    classificationId: string,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<typeof legacyClassificationEditAccessRights>
                >,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<
                        ReturnType<typeof legacyClassificationEditAccessRights>
                    >,
                    TError,
                    Awaited<
                        ReturnType<typeof legacyClassificationEditAccessRights>
                    >
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useLegacyClassificationEditAccessRights<
    TData = Awaited<ReturnType<typeof legacyClassificationEditAccessRights>>,
    TError = AxiosError<unknown>,
>(
    classificationId: string,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<typeof legacyClassificationEditAccessRights>
                >,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<
                        ReturnType<typeof legacyClassificationEditAccessRights>
                    >,
                    TError,
                    Awaited<
                        ReturnType<typeof legacyClassificationEditAccessRights>
                    >
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useLegacyClassificationEditAccessRights<
    TData = Awaited<ReturnType<typeof legacyClassificationEditAccessRights>>,
    TError = AxiosError<unknown>,
>(
    classificationId: string,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<typeof legacyClassificationEditAccessRights>
                >,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useLegacyClassificationEditAccessRights<
    TData = Awaited<ReturnType<typeof legacyClassificationEditAccessRights>>,
    TError = AxiosError<unknown>,
>(
    classificationId: string,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<typeof legacyClassificationEditAccessRights>
                >,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getLegacyClassificationEditAccessRightsQueryOptions(
        classificationId,
        options
    );

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getLegacyClassificationEditAccessRightsSuspenseQueryOptions = <
    TData = Awaited<ReturnType<typeof legacyClassificationEditAccessRights>>,
    TError = AxiosError<unknown>,
>(
    classificationId: string,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<
                    ReturnType<typeof legacyClassificationEditAccessRights>
                >,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getLegacyClassificationEditAccessRightsQueryKey(classificationId);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof legacyClassificationEditAccessRights>>
    > = ({ signal }) =>
        legacyClassificationEditAccessRights(classificationId, {
            signal,
            ...axiosOptions,
        });

    return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof legacyClassificationEditAccessRights>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type LegacyClassificationEditAccessRightsSuspenseQueryResult =
    NonNullable<
        Awaited<ReturnType<typeof legacyClassificationEditAccessRights>>
    >;
export type LegacyClassificationEditAccessRightsSuspenseQueryError =
    AxiosError<unknown>;

export function useLegacyClassificationEditAccessRightsSuspense<
    TData = Awaited<ReturnType<typeof legacyClassificationEditAccessRights>>,
    TError = AxiosError<unknown>,
>(
    classificationId: string,
    options: {
        query: Partial<
            UseSuspenseQueryOptions<
                Awaited<
                    ReturnType<typeof legacyClassificationEditAccessRights>
                >,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useLegacyClassificationEditAccessRightsSuspense<
    TData = Awaited<ReturnType<typeof legacyClassificationEditAccessRights>>,
    TError = AxiosError<unknown>,
>(
    classificationId: string,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<
                    ReturnType<typeof legacyClassificationEditAccessRights>
                >,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useLegacyClassificationEditAccessRightsSuspense<
    TData = Awaited<ReturnType<typeof legacyClassificationEditAccessRights>>,
    TError = AxiosError<unknown>,
>(
    classificationId: string,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<
                    ReturnType<typeof legacyClassificationEditAccessRights>
                >,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useLegacyClassificationEditAccessRightsSuspense<
    TData = Awaited<ReturnType<typeof legacyClassificationEditAccessRights>>,
    TError = AxiosError<unknown>,
>(
    classificationId: string,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<
                    ReturnType<typeof legacyClassificationEditAccessRights>
                >,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions =
        getLegacyClassificationEditAccessRightsSuspenseQueryOptions(
            classificationId,
            options
        );

    const query = useSuspenseQuery(
        queryOptions,
        queryClient
    ) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const legacyClassificationUpdateAccessRights = (
    classificationId: string,
    legacyUpdateClassificationAccessRightsViewModel?: LegacyUpdateClassificationAccessRightsViewModel,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<void>> => {
    return axios.post(
        `/v1/Classification/EditAccessRights/${classificationId}`,
        legacyUpdateClassificationAccessRightsViewModel,
        options
    );
};

export const getLegacyClassificationUpdateAccessRightsMutationOptions = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof legacyClassificationUpdateAccessRights>>,
        TError,
        {
            classificationId: string;
            data?: LegacyUpdateClassificationAccessRightsViewModel;
        },
        TContext
    >;
    axios?: AxiosRequestConfig;
}): UseMutationOptions<
    Awaited<ReturnType<typeof legacyClassificationUpdateAccessRights>>,
    TError,
    {
        classificationId: string;
        data?: LegacyUpdateClassificationAccessRightsViewModel;
    },
    TContext
> => {
    const mutationKey = ["legacyClassificationUpdateAccessRights"];
    const { mutation: mutationOptions, axios: axiosOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof legacyClassificationUpdateAccessRights>>,
        {
            classificationId: string;
            data?: LegacyUpdateClassificationAccessRightsViewModel;
        }
    > = (props) => {
        const { classificationId, data } = props ?? {};

        return legacyClassificationUpdateAccessRights(
            classificationId,
            data,
            axiosOptions
        );
    };

    return { mutationFn, ...mutationOptions };
};

export type LegacyClassificationUpdateAccessRightsMutationResult = NonNullable<
    Awaited<ReturnType<typeof legacyClassificationUpdateAccessRights>>
>;
export type LegacyClassificationUpdateAccessRightsMutationBody =
    | LegacyUpdateClassificationAccessRightsViewModel
    | undefined;
export type LegacyClassificationUpdateAccessRightsMutationError =
    AxiosError<unknown>;

export const useLegacyClassificationUpdateAccessRights = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof legacyClassificationUpdateAccessRights>>,
            TError,
            {
                classificationId: string;
                data?: LegacyUpdateClassificationAccessRightsViewModel;
            },
            TContext
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<typeof legacyClassificationUpdateAccessRights>>,
    TError,
    {
        classificationId: string;
        data?: LegacyUpdateClassificationAccessRightsViewModel;
    },
    TContext
> => {
    return useMutation(
        getLegacyClassificationUpdateAccessRightsMutationOptions(options),
        queryClient
    );
};
export const legacyClassificationDelete = (
    classificationId: string,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<void>> => {
    return axios.post(
        `/v1/Classification/Delete/${classificationId}`,
        undefined,
        options
    );
};

export const getLegacyClassificationDeleteMutationOptions = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof legacyClassificationDelete>>,
        TError,
        { classificationId: string },
        TContext
    >;
    axios?: AxiosRequestConfig;
}): UseMutationOptions<
    Awaited<ReturnType<typeof legacyClassificationDelete>>,
    TError,
    { classificationId: string },
    TContext
> => {
    const mutationKey = ["legacyClassificationDelete"];
    const { mutation: mutationOptions, axios: axiosOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof legacyClassificationDelete>>,
        { classificationId: string }
    > = (props) => {
        const { classificationId } = props ?? {};

        return legacyClassificationDelete(classificationId, axiosOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type LegacyClassificationDeleteMutationResult = NonNullable<
    Awaited<ReturnType<typeof legacyClassificationDelete>>
>;

export type LegacyClassificationDeleteMutationError = AxiosError<unknown>;

export const useLegacyClassificationDelete = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof legacyClassificationDelete>>,
            TError,
            { classificationId: string },
            TContext
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<typeof legacyClassificationDelete>>,
    TError,
    { classificationId: string },
    TContext
> => {
    return useMutation(
        getLegacyClassificationDeleteMutationOptions(options),
        queryClient
    );
};
